/**
 * Simple debug logger for use in non-Vue contexts
 * This version checks for window.DP3_DEBUG flag which is set by the DevTools debug mode toggle
 */
export const simpleDebugLog = {
  log(...args: any[]): void {
    if (this.isEnabled()) {
      console.log(...args);
    }
  },

  warn(...args: any[]): void {
    if (this.isEnabled()) {
      console.warn(...args);
    }
  },

  error(...args: any[]): void {
    if (this.isEnabled()) {
      console.error(...args);
    }
  },

  info(...args: any[]): void {
    if (this.isEnabled()) {
      console.info(...args);
    }
  },

  /**
   * Check if debug mode is enabled by looking at the global flag
   * This flag is synced with the DevTools store in the useDebugLogger composable
   */
  isEnabled(): boolean {
    return typeof window !== 'undefined' && (window as any).DP3_DEBUG === true;
  },
};
